var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as padLeft from 'pad-left';
import { feathersServices } from 'src/feathers';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import 'antd/lib/tabs/style/index.css';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Popconfirm from 'antd/lib/popconfirm';
import FormTeamPromote from './FormPromote/FormTeamPromote';
import FormAthletePromote from './FormPromote/FormAthletePromote';
import FormTeamScore from './FormScore/FormTeamScore';
import FormAthleteScore from './FormScore/FormAthleteScore';
import FormAthleteScoreRouteHistory from './FormAthleteScoreRouteHistory';
var formStyles = require('src/imports/styles/extend.form.scss');
var selfStyles = require('../styles.scss');
var DashboardFormAthlete = (function (_super) {
    __extends(DashboardFormAthlete, _super);
    function DashboardFormAthlete(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeTabKey: undefined,
        };
        _this.handleCreateTeamScore = _this.handleCreateTeamScore.bind(_this);
        _this.handlePatchTeamScore = _this.handlePatchTeamScore.bind(_this);
        _this.handleDeleteTeamScore = _this.handleDeleteTeamScore.bind(_this);
        _this.handleCreateAthleteScore = _this.handleCreateAthleteScore.bind(_this);
        _this.handlePatchAthleteScore = _this.handlePatchAthleteScore.bind(_this);
        _this.handleDeleteAthleteScore = _this.handleDeleteAthleteScore.bind(_this);
        return _this;
    }
    DashboardFormAthlete.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (nextProps.store.teamScore === this.props.store.teamScore &&
            nextProps.store.athleteScore === this.props.store.athleteScore) {
            return;
        }
        if (this.state.activeTabKey === 'team' &&
            !nextProps.store.teamScore) {
            this.setState({ activeTabKey: 'athlete' });
        }
        else if (this.state.activeTabKey === 'athlete' &&
            !nextProps.store.athleteScore) {
            this.setState({ activeTabKey: 'team' });
        }
    };
    DashboardFormAthlete.prototype.handleCreateTeamScore = function (ts) {
        return this.props.dispatch(feathersServices.teamScores.create(ts));
    };
    DashboardFormAthlete.prototype.handlePatchTeamScore = function (ts) {
        return this.props.dispatch(feathersServices.teamScores.patch(ts.id, ts));
    };
    DashboardFormAthlete.prototype.handleDeleteTeamScore = function (ts) {
        return this.props.dispatch(feathersServices.teamScores.remove(ts.id));
    };
    DashboardFormAthlete.prototype.handleCreateAthleteScore = function (as) {
        return this.props.dispatch(feathersServices.athleteScores.create(as));
    };
    DashboardFormAthlete.prototype.handlePatchAthleteScore = function (as) {
        return this.props.dispatch(feathersServices.athleteScores.patch(as.id, as));
    };
    DashboardFormAthlete.prototype.handleDeleteAthleteScore = function (as) {
        return this.props.dispatch(feathersServices.athleteScores.remove(as.id));
    };
    DashboardFormAthlete.prototype.render = function () {
        var _this = this;
        var rounds = this.props.store.rounds;
        var teamScores = this.props.store.teamScores;
        var athleteScores = this.props.store.athleteScores;
        var event = this.props.store.event;
        var category = this.props.store.category;
        var round = this.props.store.round;
        var team = this.props.store.team;
        var teamScore = this.props.store.teamScore;
        var athlete = this.props.store.athlete;
        var athleteScore = this.props.store.athleteScore;
        if (!rounds ||
            !teamScores ||
            !athleteScores ||
            !event ||
            !category ||
            !round) {
            return null;
        }
        var isTeam = team && teamScore;
        var isAthlete = athlete && athleteScore;
        if (!isTeam && !isAthlete) {
            return null;
        }
        var cardTabList = [];
        var cardContentList = {};
        if (team && teamScore) {
            cardTabList.push({
                key: 'team',
                tab: React.createElement("span", null, "Team"),
            });
            cardContentList.team = (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: formStyles.header + " " + selfStyles.cardHeader }, team.name),
                React.createElement(Link, { to: "/event/" + event.subdomain + "/teams/" + team.id, className: selfStyles.formScoreLink }, "[Edit team info]"),
                round.index > 0 && (React.createElement(Popconfirm, { title: (React.createElement("div", { className: selfStyles.formScorePopconfirm },
                        React.createElement("h3", null, "Remove Team from round"),
                        React.createElement("p", null,
                            "This will remove the team, ",
                            React.createElement("strong", null, team.name),
                            ", from ",
                            React.createElement("strong", null,
                                round.name,
                                ", ",
                                category.name),
                            " and delete their score, status and comments for this round."),
                        React.createElement("p", null, "This action is irreversible!"),
                        React.createElement("small", null, "Their scores for other rounds will be untouched."))), onConfirm: function () { _this.handleDeleteTeamScore(teamScore); } },
                    React.createElement("a", null, "[Remove from round]"))),
                React.createElement(FormTeamPromote, { rounds: rounds, teamScores: teamScores, category: category, round: round, team: team, teamScore: teamScore, teamAthletes: this.props.store.teamAthletes || [], teamAthleteScores: this.props.store.teamAthleteScores || [], handleCreateTeamScore: this.handleCreateTeamScore, handlePatchTeamScore: this.handlePatchTeamScore, handleCreateAthleteScore: this.handleCreateAthleteScore, handlePatchAthleteScore: this.handlePatchAthleteScore }),
                React.createElement(Divider, null),
                React.createElement(FormTeamScore, { teamScore: teamScore, handlePatchTeamScore: this.handlePatchTeamScore })));
        }
        if (athlete && athleteScore) {
            cardTabList.push({
                key: 'athlete',
                tab: React.createElement("span", null, "Athlete"),
            });
            cardContentList.athlete = (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: formStyles.header + " " + selfStyles.cardHeader },
                    round.code,
                    padLeft(athleteScore.bibNumber, 3, '0'),
                    ": ",
                    athlete.name),
                React.createElement(Link, { to: "/event/" + event.subdomain + "/athletes/" + athlete.id, className: selfStyles.formScoreLink }, "[Edit athlete info]"),
                round.index > 0 && (React.createElement(Popconfirm, { title: (React.createElement("div", { className: selfStyles.formScorePopconfirm },
                        React.createElement("h3", null, "Remove Athlete from round"),
                        React.createElement("p", null,
                            "This will remove the athlete, ",
                            React.createElement("strong", null,
                                round.code,
                                padLeft(athleteScore.bibNumber, 3, '0'),
                                " ",
                                athlete.name),
                            ", from ",
                            React.createElement("strong", null,
                                round.name,
                                ", ",
                                category.name),
                            " and delete their score, status and comments for this round."),
                        React.createElement("p", null, "This action is irreversible!"),
                        React.createElement("small", null, "Note: Their scores for other rounds will be untouched."))), onConfirm: function () { _this.handleDeleteAthleteScore(athleteScore); } },
                    React.createElement("a", null, "[Remove from round]"))),
                !athleteScore.teamId && (React.createElement(React.Fragment, null,
                    React.createElement(FormAthletePromote, { rounds: rounds, athleteScores: athleteScores, category: category, round: round, athlete: athlete, athleteScore: athleteScore, handleCreateAthleteScore: this.handleCreateAthleteScore, handlePatchAthleteScore: this.handlePatchAthleteScore }),
                    React.createElement(Divider, null))),
                React.createElement(FormAthleteScore, { athleteScore: athleteScore, handlePatchAthleteScore: this.handlePatchAthleteScore })));
        }
        if (athlete && athleteScore) {
            cardTabList.push({
                key: 'athleteScoreRoute',
                tab: React.createElement("span", null, "Score"),
            });
            cardContentList.athleteScoreRoute = (React.createElement(React.Fragment, null,
                React.createElement("h2", { className: formStyles.header + " " + selfStyles.cardHeader },
                    round.code,
                    padLeft(athleteScore.bibNumber, 3, '0'),
                    ": ",
                    athlete.name),
                React.createElement(FormAthleteScoreRouteHistory, null)));
        }
        return (React.createElement(Card, { className: formStyles.card, tabList: cardTabList, activeTabKey: this.state.activeTabKey || cardTabList[0].key, onTabChange: function (key) { return _this.setState({ activeTabKey: key }); } }, cardContentList[this.state.activeTabKey || cardTabList[0].key]));
    };
    return DashboardFormAthlete;
}(React.Component));
var mapStateToProps = function (state) {
    var categoryId = state.scoreboard.categoryId;
    var roundId = state.scoreboard.roundId;
    var teamId = state.scoreboard.teamId;
    var athleteId = state.scoreboard.athleteId;
    var athleteScoreId = state.scoreboard.athleteScoreId;
    var team = state.workspaceEvent.teams && state.workspaceEvent.teams.data.find(function (t) { return t.id === teamId; });
    var teamScore = state.workspaceEvent.teamScores && state.workspaceEvent.teamScores.data.find(function (ts) { return ts.teamId === teamId && ts.roundId === roundId; });
    var teamAthletes = state.workspaceEvent.athletes && state.workspaceEvent.athletes.data.filter(function (a) { return a.teamId === teamId; });
    var teamAthleteScores = state.workspaceEvent.athleteScores && state.workspaceEvent.athleteScores.data.filter(function (as) { return as.teamId === teamId && as.roundId === roundId; });
    var athlete = state.workspaceEvent.athletes && state.workspaceEvent.athletes.data.find(function (a) { return a.id === athleteId; });
    var athleteScore = state.workspaceEvent.athleteScores && state.workspaceEvent.athleteScores.data.find(function (a) { return a.id === athleteScoreId; });
    if ((teamScore && teamScore.roundId !== roundId) ||
        (athleteScore && athleteScore.roundId !== roundId)) {
        return { store: {} };
    }
    return {
        store: {
            team: team,
            teamScore: teamScore,
            teamAthletes: teamAthletes,
            teamAthleteScores: teamAthleteScores,
            athlete: athlete,
            athleteScore: athleteScore,
            rounds: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data.filter(function (r) { return r.categoryId === categoryId; }),
            teamScores: state.workspaceEvent.teamScores && state.workspaceEvent.teamScores.data.filter(function (a) { return a.teamId === teamId; }),
            athleteScores: state.workspaceEvent.athleteScores && state.workspaceEvent.athleteScores.data.filter(function (a) { return a.athleteId === athleteId; }),
            event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
            category: state.workspaceEvent.categories && state.workspaceEvent.categories.data.find(function (c) { return c.id === categoryId; }),
            round: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data.find(function (r) { return r.id === roundId; }),
        },
        scoreboard: state.scoreboard,
    };
};
export default connect(mapStateToProps)(DashboardFormAthlete);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormTeamAthleteScore/index.tsx
// module id = 847
// module chunks = 0